// removed by extract-text-webpack-plugin
module.exports = {"modal":"_3gdT_JT1IjRSrCkZ-_4xI-","formGroup":"_2RwhOWP2FguJe9BAmbjZuP"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fadabf1","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./~/vue-components/activity-summary/components/secondary-actions/ChangeTranscriptionLanguage/ChangeTranscriptionLanguageModal.less
// module id = NmNo
// module chunks = 1